import React, { useState } from 'react'
import Tooltip from '@mui/material/Tooltip'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

function CustomTooltip({
  children,
  tooltipBorderColor,
  tooltipBackgroundColor,
  hasIcon = false,
  icon = null,
  tooltipText,
  placement,
  customStyle = null,
  customContent = null,
}) {
  const [openTooltip, setOpenTooltip] = useState(false)
  return (
    <Tooltip
      open={openTooltip}
      placement={placement}
      PopperProps={{
        sx: {
          '& .MuiTooltip-tooltip': {
            borderRadius: '0.25rem',
            border: '0.5px solid ' + tooltipBorderColor,
            backgroundColor: tooltipBackgroundColor,
          },
        },
      }}
      title={
        <Grid
          container
          style={{
            // padding: '0.5rem',
            flexDirection: 'row',
            flexWrap: 'nowrap',
          }}>
          {hasIcon && icon && (
            <Grid
              style={{
                display: 'flex',
                justifyContent: 'center',
                paddingRight: '0.5rem',
              }}>
              {icon}
            </Grid>
          )}
          <Grid>
            {tooltipText && <Typography variant={'body_xxs_medium'}>{tooltipText}</Typography>}
            {customContent && <>{customContent}</>}
          </Grid>
        </Grid>
      }>
      <div
        onMouseEnter={() => setOpenTooltip(true)}
        onMouseLeave={() => setOpenTooltip(false)}
        style={
          customStyle ?? {
            paddingLeft: '0.5rem',
            display: 'flex',
            justifyContent: 'center',
          }
        }>
        {children}
      </div>
    </Tooltip>
  )
}

export default CustomTooltip
